export const useFormatBrandInfo = () => {
  const formatNumberToOneDigitFraction = (value) => Number(value).toFixed(1);

  const getInfoLabel = ({ savings, cashBack }) => {
    const finalSavings = savings
      ? `Up to ${formatNumberToOneDigitFraction(savings)}% off`
      : "";
    const finalCashback = cashBack
      ? `${formatNumberToOneDigitFraction(cashBack)}% GCX Cash`
      : "";
    const separator = savings && cashBack ? " | " : "";
    return `${finalSavings} ${separator} ${finalCashback}`.trim();
  };
  return {
    getInfoLabel
  };
};
